
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getVersionList, setCurrentVersion } from '@/api/version';
import Edit from './edit.vue';
import { toast } from '@/utils/common';
import { eAuditStatus, eUpdateType, eUpdateVersion, iVersion, iVersionSearch } from '@/interface/version';
import { PageQuery } from '@/mixins/page_query';
import { eEndPoint } from '@/interface/hot-game';
@Component({
  components: { Edit },
})
export default class HotGame extends Mixins(PageQuery) {
  tableModel: iVersion[] = [];
  loading: boolean = false;
  visible: boolean = false;
  andriod: eUpdateVersion = eUpdateVersion.ANDRIOD;
  ios: eUpdateVersion = eUpdateVersion.IOS;
  no: eUpdateVersion = eUpdateVersion.NO;
  seletUpdate: eUpdateType = eUpdateType.SELECTUPDATE;
  select: eUpdateType = eUpdateType.SELECT;
  model: iVersion = {
    id: 0,
    scope: this.ios,
    version: '',
    change_log: [],
    update_type: eUpdateType.SELECT,
    created_at: '',
    current: false,
    audit_status: eAuditStatus.CLOSE,
  };
  route_type: number = 0;
  ActFree: number = -1;
  total: number = 0;
  exitTitle: string = '新增版本';
  searchInfo: iVersionSearch = {
    search_key: '',
    scope: this.ios,
  };

  /* 查询 */
  searchList() {
    // this.page_query.page = 1;
    this.getList();
  }
  /* 编辑 */
  editRow(row: iVersion) {
    this.clear();
    this.visible = true;

    this.model = row;
    this.exitTitle = '编辑版本';
  }
  addVersion() {
    this.clear();
    this.visible = true;
    this.exitTitle = '新增版本';
  }
  getChangeLog(list: any) {
    let str = '';
    list.forEach((item: any) => {
      str += '<div>' + item + '</div>';
    });

    return str;
  }
  async getList() {
    this.loading = true;
    try {
      const query = {
        ...this.page_query,
        ...this.searchInfo,
      };
      const res = await getVersionList(query);

      if (res && res.code == 0) {
        this.tableModel = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }

  clear() {
    this.model = {
      id: 0,
      version: '',
      change_log: [],
      update_type: eUpdateType.SELECTUPDATE,
      created_at: '',
      current: false,
      scope: this.ios,
      audit_status: eAuditStatus.CLOSE,
    };
  }
  editOk() {
    this.clear();
    this.getList();
    this.visible = false;
  }

  mounted() {
    this.pageFn = this.searchList;
    this.searchList();
  }
}
